import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/_legacy/agency/create")({
  beforeLoad: () => {
    throw redirect({to: "/admins/agency/create", replace: true});
  },
});
